var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.441,
    height: 56.441,
    viewBox: "0 0 56.441 56.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(-592.559 -3387)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_2",
    "data-name": "Rectangle 3 copy 2",
    width: 56.441,
    height: 56.441,
    rx: 15,
    transform: "translate(592.559 3387)",
    fill: "#59be3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_15_attachment_paper_clip",
    "data-name": "15 attachment,paper clip",
    transform: "translate(605.697 3398.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M11.485,31.936A10.007,10.007,0,0,1,4.337,14.866L16.546,2.729A7.147,7.147,0,0,1,26.653,12.836L15.116,24.373a4.289,4.289,0,1,1-6.062-6.062l7.92-7.934L19,12.407l-7.934,7.92a1.435,1.435,0,1,0,2.03,2.03L24.637,10.82a4.3,4.3,0,1,0-6.076-6.076L6.438,16.882A7.147,7.147,0,1,0,16.546,26.99l7.848-7.835,2.016,2.016-7.849,7.849a10.007,10.007,0,0,1-7.077,2.916Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.34212b336e371a384d9f9d9f59732643.svg";
export { ForwardRef as ReactComponent };